export default {
  title: "Кардарлар тизмеси",
  allClients: "Бардык кардарлар",
  internalClients: "Ички",
  internalClient: "Ички кардар",
  externalClients: "Сырттагы",
  externalClient: "Сырттагы кардар",
  clientsType: "Кардардын түрү",

  noEnitity: {
    label: "Бетке кирүү мүмкүн эмес",
    text: "Сиздин юридикалык жак модерацияда турат",
  },
  needBuyTariff: "Кардарларды санариптештирүү үчүн тарифти сатып алуу керек",
  noTradingPoint: "Сизде азырынча соода нүктөлөрү жок",
  digitizeClients: "Кардарларды санариптештирип, аларды тизмеңизде көрсөтүңүз",

  table: {
    inviteDate: "Каттоо датасы",
    fullName: "Толук аты-жөнү",
    phone: "Телефон номери",
    receiptsCount: "Сатып алуулардын саны",
    receiptsSum: "Сатып алуулардын суммасы",
  },

  clientCard: {
    title: "Кардар тууралуу маалымат",
    client: {
      title: "Кардар",
      fields: {
        fullName: "Толук аты-жөнү",
        gender: "Жынысы",
        birthDate: "Туулган күнү",
        phone: "Телефон номери",
        clientType: "Кардардын түрү",
        inviteDate: "Каттоо датасы",
        regSource: "Каттоо булагы",
        rcCard: "RC карта номери",
        note: "Эскертме",
      },
      phoneHint:
        "Телефон номери гана акы төлөнгөн тарифтерде көрсөтүлөт жана кардар маалыматтарын берүү жана маркетинг сунуштарын алуу боюнча макулдук берген учурда гана көрүнөт.",
    },
    statistic: {
      title: "Статистика",
      block: {
        avgReceiptsSum: "Орточо чек",
        receiptsCount: "Сатып алуулардын саны",
        receiptsSum: "Айланма",
        writeOffPointsSum: "Баллаар менен төлөө",
      },
      totalNumberOfVisit: "Бардык келгендер",
      firstVisit: "Биринчи келүү",
      lastVisit: "Акыркы келүү",
      visitedShops: "Келген соода жайлары",
    },
    receipts: {
      title: "Чектер",
      emptyState: {
        title: "Чектер жок",
        description: "Кардар сатып алуудан кийин бул жерде пайда болот",
      },
    },
    reviews: {
      title: "Сын-пикирлер",
      noReviews: "Азырынча сын-пикирлер жок",
      itsAppearHere: "Кардар сын-пикир калтырганда бул жерде көрүнөт",
    },
  },
  pointsAwarded: "Баллар кошулду",
  digitizingOnYourTariffNotAvailable:
    "Сиздин тарифте кардарды санариптештирүү мүмкүн эмес",
  digitizingIntoRC: "Кардарды санариптештирүү<br> RC PAY аркылуу",
  fastDigitizingIntoTg: "Жылдам санариптештирүү<br> Telegram-бот аркылуу",
  abilityToUseLinkOrQRcode:
    "Жаңы колдонуучуларды чакыруу үчүн шилтемени же QR-кодду колдонуу мүмкүнчүлүгү тарифти сатып алгандан кийин ачылат.",
  inviteClients: "Кардарларды чакыруу",
  selectPointToGenerateQR:
    "Жаңы кардарларды RC PAYге каттоо үчүн шилтеме жана&nbsp;QR-код түзүү үчүн соода нүктөнү тандаңыз.",
  invitingtoLoyaltyProgram: "Сыйлуулук программасына чакыруу",
  downloadQR: "QR-кодду жүктөө",
  linkCopied: "Шилтеме көчүрүлдү",
  share: "Бөлүшүү",
  joinToLoyaltyProgram: "Сыйлуулук программасына кошул!",
  receiveDiscountNotives:
    "Ар кандай арзандатуулар жана эксклюзивдүү акциялар тууралуу кабарланууларды алыңыз. Ар бир сатып алуу үчүн сыйлык жана баллаар менен төлөө 99.9% чейин.",
  clientServiceAndAppRcPay:
    "rcpay.ru кардар кызматы жана RC PAY тиркемеси – пайдалуу жана ыңгайлуу шопинг дүйнөсүнө сиздин жол көрсөтүүчүңүз!",
};
